const COLOURS = {
  PRIMARY: "#5BFFC1",
  HIGHLIGHT: "#5BFFC1",
  WHITE: "#FFFFFF",
  GREY_1: "#444B48",
  GREY_2: "#66706C",
  GREY_3: "#8C9793",
  GREY_BORDER: "#E4E7E6",
  SHADOW: "rgba(0, 97, 57, 0.1)",
  BODY_TEXT: "", // defined below
  HEADINGS: "", // defined below
};

COLOURS.BODY_TEXT = COLOURS.GREY_1;
COLOURS.HEADINGS = COLOURS.GREY_1;

export default COLOURS;
